(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/fractiongames/assets/react/contexts/container-context-provider.js') >= 0) return;  svs.modules.push('/components/numbergames/fractiongames/assets/react/contexts/container-context-provider.js');

'use strict';

const _React = React,
  createContext = _React.createContext,
  useContext = _React.useContext,
  useMemo = _React.useMemo;
const _ReactRedux = ReactRedux,
  useSelector = _ReactRedux.useSelector;
const CampaignContext = svs.numbergames.fractiongames.contexts.CampaignContext;
const createContainerSelectors = svs.numbergames.fractiongames.redux.slices.containers.selectors.createContainerSelectors;
const ContainerContext = createContext({});
const ContainerContextProvider = _ref => {
  let children = _ref.children,
    containerId = _ref.containerId;
  const selectors = useMemo(() => createContainerSelectors(containerId), [containerId]);
  const _useContext = useContext(CampaignContext),
    hasActiveCampaign = _useContext.hasActiveCampaign,
    getCampaignInfo = _useContext.getCampaignInfo,
    getCampaignChances = _useContext.getCampaignChances;
  const productNumeric = useSelector(selectors.selectProductNumeric);
  const drawNumber = useSelector(selectors.selectDrawNumber);
  const totalPrice = useSelector(selectors.selectTotalPrice);
  const game = useSelector(selectors.selectGame);
  const containerHasActiveCampaign = useMemo(() => hasActiveCampaign(productNumeric, drawNumber), [hasActiveCampaign, productNumeric, drawNumber]);
  const containerCampaignInfo = useMemo(() => getCampaignInfo(productNumeric, drawNumber), [getCampaignInfo, productNumeric, drawNumber]);
  const containerCampaignChances = useMemo(() => getCampaignChances({
    productNumeric,
    drawNumber,
    totalPrice,
    game
  }), [getCampaignChances, productNumeric, drawNumber, totalPrice, game]);
  return React.createElement(ContainerContext.Provider, {
    value: {
      selectors,
      hasActiveCampaign: containerHasActiveCampaign,
      campaignInfo: containerCampaignInfo,
      campaignChances: containerCampaignChances
    }
  }, children);
};
Object.assign(svs.numbergames.fractiongames.contexts, {
  ContainerContext,
  ContainerContextProvider
});

 })(window);